import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    user: null,
    projects: []
}


const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload;
        },
        setProjects: (state, actions) => {
            state.projects = actions.payload;
        },
    },
});


export const {
  setUser,
  setProjects
} = userSlice.actions;

export default userSlice.reducer;
